import * as React from "react";
import {
    DetailsAnimationOuter,
    DetailsAnimationMiddle,
    DetailsContentContainer,
    LegendContainer,
    LegendColor,
} from "./chart-legend-style";
import { PieChartData } from "../minimal-chart/types";
import { formatNumber } from "common/format-number";

type Props = Readonly<{
    showDetails: boolean;
    caption?: string;
    chartData?: PieChartData[];
    isSingleSeries?: boolean;
    seriesData?: { [key: string]: string };
}>;

interface State {}

export default class ChartLegend extends React.Component<Props, State> {
    public render() {
        const { showDetails, caption, chartData, isSingleSeries, seriesData } = this.props;

        return (
            <>
                <DetailsAnimationOuter className={`${showDetails ? "show" : "hidden"}`}>
                    <DetailsAnimationMiddle>
                        <DetailsContentContainer>
                            {showDetails && (
                                <>
                                    <LegendContainer>
                                        {caption && <div className="graph-description">{caption}</div>}
                                        {!isSingleSeries && seriesData
                                            ? Object.keys(seriesData).map((item, i) => {
                                                  return (
                                                      <div className="legend-item" key={i}>
                                                          <LegendColor color={seriesData[item]} />
                                                          <div className="legend-title">{item}</div>
                                                      </div>
                                                  );
                                              })
                                            : chartData &&
                                              chartData.map((item, i) => {
                                                  return (
                                                      <div className="legend-item" key={i}>
                                                          <LegendColor color={item.color} />
                                                          <div className="legend-title">{item.title}</div>
                                                          <div className="legend-value">
                                                              {item.displayValue ?? formatNumber(item.value)}
                                                          </div>
                                                      </div>
                                                  );
                                              })}
                                    </LegendContainer>
                                </>
                            )}
                        </DetailsContentContainer>
                    </DetailsAnimationMiddle>
                </DetailsAnimationOuter>
            </>
        );
    }
}
